import { i18nMark } from 'lingui-react';

const messages = {
  viewAs: i18nMark('View As'),
};

export default messages;



// WEBPACK FOOTER //
// ./components/ViewSelector/messages.js